<div class="col-md-6">
  <label class="form-label">Empregador</label>
  <select
    class="form-select"
    name="jornadaEmpregador"
    [ngModel]="empregadorSelecionado"
    (ngModelChange)="empregadorSelecionadoChange.emit($event)"
    required>
    <option value="">Selecione</option>
    <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
  </select>
</div>

<div class="col-md-6">
  <label class="form-label">Jornada existente</label>
  <select
    class="form-select"
    name="jornadaExistente"
    [ngModel]="jornada.id || ''"
    (ngModelChange)="jornadaSelecionada.emit($event)">
    <option value="">Nova jornada</option>
    <option *ngFor="let item of jornadas" [value]="item.id">
      {{ item.nome }}{{ item.padrao ? ' (padrao)' : '' }}
    </option>
  </select>
</div>

<div class="col-md-5">
  <label class="form-label">Nome da jornada</label>
  <input
    class="form-control"
    name="nomeJornada"
    [(ngModel)]="jornada.nome"
    (ngModelChange)="emitirJornada()"
    placeholder="Estagiarios, Limpeza, Administrativo"
    required>
</div>

<div class="col-md-3">
  <label class="form-label">Tolerancia padrao</label>
  <input
    class="form-control"
    type="number"
    name="toleranciaJornada"
    min="0"
    max="120"
    [(ngModel)]="jornada.toleranciaMinutos"
    (ngModelChange)="emitirJornada()">
</div>

<div class="col-md-4 d-flex align-items-end gap-4">
  <div class="form-check form-switch pb-2">
    <input
      class="form-check-input"
      type="checkbox"
      name="janelaJornada"
      [(ngModel)]="jornada.validarJanelaPonto"
      (ngModelChange)="emitirJornada()">
    <label class="form-check-label">Validar tolerancia</label>
  </div>
  <div class="form-check pb-2">
    <input
      class="form-check-input"
      type="checkbox"
      name="padraoJornada"
      [(ngModel)]="jornada.padrao"
      (ngModelChange)="emitirJornada()">
    <label class="form-check-label">Padrao</label>
  </div>
  <div class="form-check pb-2">
    <input
      class="form-check-input"
      type="checkbox"
      name="ativaJornada"
      [(ngModel)]="jornada.ativa"
      (ngModelChange)="emitirJornada()">
    <label class="form-check-label">Ativa</label>
  </div>
</div>

<div class="col-12" *ngIf="!jornada.validarJanelaPonto">
  <div class="text-secondary small">
    Validar tolerancia desligado: aceita horario alternativo e grava na proxima coluna vazia (1a, 2a, 3a, 4a).
  </div>
</div>
